'use strict'

const I18N_HU = {
    'project.menu.variant.left': 'Bal',
    'project.menu.variant.right': 'Jobb',
    'project.menu.tooltip.with_variants': 'Művelet a következővel: {variants}.',
    'project.menu.tooltip.default': 'Művelet a következővel: Középső útvonal.',
    'project.menu.choose_variant_prompt': 'Kérem válasszon hogy melyik útvonallal szeretne műveletet végezni!',
    'project.menu.choose_variant_prompt_with_action': '{action} - Kérem válasszon hogy melyik útvonallal szeretne műveletet végezni!',
    'project.menu.choose_variant_legend': 'Jelmagyarázat: <strong>B</strong> = bal, <strong>K</strong> = közép, <strong>J</strong> = jobb.',
    'common.ok': 'OK',
    'common.cancel': 'Mégse',
    'common.rotate_axis_90': 'Tengely forgatása 90 fokkal',
    'common.save': 'Mentés',
    'common.back': 'Vissza',
    'common.close_no_save': 'Bezárás (Nincs mentés)',
    'common.help': 'Segítség',
    'common.field': 'Mező',
    'common.copy': 'Másolás',
    'common.value': 'Érték',
    'common.error': 'Hiba',
    'common.done': 'KÉSZ',
    'common.no_change': 'Nincs változás',
    'common.unknown': 'ismeretlen',
    'common.null': 'null',
    'common.unknown_error': 'Ismeretlen hiba',
    'common.warning': 'Figyelmeztetés',
    'common.previous': 'Előző',
    'common.next': 'Következő',
    'common.undo': 'Visszavonás',
    'common.redo': 'Ismétlés',
    'common.settings': 'Beállítások',
    'common.experimental': 'Kísérleti funkció! Nagy valószínűséggel hibák vannak, használata saját felelősségre.',

    'auth.logged_in_logout_tooltip': 'Bejelentkezve: {name}, kijelentkezik?',
    'auth.login_google_tooltip': 'Bejelentkezés: Google',
    'auth.please_login': 'Kérem, jelentkezzen be!',
    'auth.use_other_google_account': 'Másik Google fiókot használok',
    'auth.use_other_google_account_tooltip': 'Másik Google fiók kiválasztása vagy új Google bejelentkezés',
    'auth.permission_missing': 'Hiányzó jogosultság!',
    'auth.login.title': 'Bejelentkezés',
    'auth.login.email': 'E-mail',
    'auth.login.password': 'Jelszó',
    'auth.login.submit': 'Bejelentkezés',

    'layout.main.nav.scroll_left': 'Navbar görgetése balra',
    'layout.main.nav.scroll_right': 'Navbar görgetése jobbra',
    'layout.main.menu.new_route': 'Új útvonal',
    'layout.main.menu.new_kml': 'Új KML',
    'layout.main.menu.new_kmz': 'Új KMZ',
    'layout.main.menu.new_kmz_suffix': '(wpmz/template.kml;waylines.wpml)',
    'layout.main.menu.close_edited_route': 'Útvonal bezárása',
    'layout.main.toolbar.project_settings': 'Projekt adatai',
    'layout.main.toolbar.center_all': 'Középre (teljes KML/KMZ)',
    'layout.main.toolbar.select_polygon': 'Poligon kijelölés',
    'layout.main.toolbar.select_all_toggle': 'Összes pont kijelölése / Kijelölés megszüntetése',
    'layout.main.toolbar.delete_selected': 'Kijelöltek törlése',
    'layout.main.toolbar.grid_helper': 'Rács beállítások',
    'layout.main.toolbar.insert_point': 'Pont: kattintás = aktiválás, húzás = mozgatás, térkép kattintás = új pont, aktív pont mellett a beszúrás automatikusan igazodik',
    'layout.main.toolbar.edit_selected': 'Kijelöltek szerkesztése',
    'layout.main.toolbar.zoom_out': 'Távolabb',
    'layout.main.toolbar.zoom_in': 'Közelebb',
    'layout.main.toolbar.full_region': 'Teljes régió',
    'layout.main.toolbar.my_location': 'Helyzetem',
    'layout.main.filter.date_all': 'Szűrő - Dátum - Teljes NOTAM',
    'layout.main.filter.date_today': 'Szűrő - Dátum - Csak MA',
    'layout.main.filter.airspace_all_none': 'Szűrő - Légtér típus - Összes / Egyik sem',
    'layout.main.filter.airspace_labels': 'Szűrő - Légtér típus - Címkék',
    'layout.main.info.refresh_sources': 'Térkép forrás frissítése',
    'layout.main.info.electron_download': 'Electron asztali app letöltése',

    'geo.browser_unavailable': 'A böngésző geolokációja nem érhető el.',
    'geo.location_failed': 'A helyzet meghatározása sikertelen.',
    'geo.permission_denied': 'A helymeghatározás tiltva van a böngészőben vagy az oldalon.',
    'geo.position_unavailable': 'A helyzet most nem érhető el. Ellenőrizd a GPS/Wi-Fi/hálózati helymeghatározást, majd próbáld újra.',
    'geo.timeout': 'A helymeghatározás időtúllépés miatt megszakadt. Próbáld újra.',
    'geo.secure_context_required': 'A helymeghatározás csak biztonságos (HTTPS) környezetben érhető el.',
    'geo.failed_prefix': 'A helymeghatározás sikertelen:',

    'project.no_editable_project': 'Nincs szerkeszthető projekt.',
    'project.data_unavailable': 'A projekt adatai nem érhetők el.',
    'project.no_editable_field': 'Nincs projekt szintű szerkeszthető mező.',
    'project.dialog_title': 'Projekt adatai ({type})',
    'project.export_filename_label': 'Fájlnév (csak exporthoz)',
    'project.export_filename_help': 'Ez a mező nem kerül mentésre a KMZ/KML tartalmába, csak az export fájlnevet adja meg.',
    'project.export_filename_refresh': 'Fájlnév frissítése',

    'height_tool.dropdown_title': 'DEM alapú magasság számítás',
    'height_tool.confirm_overwrite': 'Biztos, hogy a {field} értékeit felül akarja írni?',
    'height_tool.confirm_formula': 'Új magasság = Földfelszín magasság ({provider}) + project.height',
    'height_tool.project_height_empty': 'A project.height mező üres (vagy nulla)!',
    'height_tool.project_height_prompt': 'Ha megad egy értéket, a rendszer a(z) {field} újraszámítása előtt minden érintett pontnál erre állítja a project.height mezőt.',
    'height_tool.project_height_input_label': 'A project.height értéke legyen minden pontnál:',
    'height_tool.project_height_still_empty': 'A project.height mező értéke továbbra is hiányzik.',
    'height_tool.invalid_coords': 'Nem minden pont rendelkezik érvényes koordinátával.',
    'height_tool.loading': 'DEM lekérés és előnézet készítése ({provider})...',
    'height_tool.dem_missing': 'A DEM eredmény nem érkezett meg minden ponthoz.',
    'height_tool.preview_title': 'Magasság számítás előnézet',
    'height_tool.col_point_name': 'Pont',
    'height_tool.col_project_height': 'project.height',
    'height_tool.col_dem_provider': 'DEM szolgáltató',
    'height_tool.col_dem_value': 'Földfelszín magasság',
    'height_tool.manual_value_suffix': 'kézi érték',
    'height_tool.point_name_fallback': 'WP {index}',

    'action.kml.title': 'KML akciók',
    'action.kmz.title': 'KMZ akciók',
    'action.none': 'Nincs akció. Új akció hozzáadható.',
    'action.item': 'Akció #{n}',
    'action.type': 'Akció típusa',
    'action.param': 'Akció paraméter',
    'action.params': 'Paraméterek',
    'action.no_param': 'Nincs paraméter.',
    'action.add': 'Akció hozzáadása',
    'action.delete': 'Törlés',
    'action.edit_custom': 'Egyedi akció szerkesztése',
    'action.custom_value_edit': 'Egyedi érték szerkesztése',
    'action.param_value': 'Akció paraméter értéke: {value}',
    'action.param_help_short': 'Akció paraméter értéke.',
    'action.param_help_detailed': 'Az akció futásának numerikus/szöveges paramétere. Hatás: időzítés, szög vagy más akciófüggő viselkedés.',
    'action.type_help_short': 'Waypoint akció típusának választása.',
    'action.type_help_detailed': 'A waypoint elérésekor végrehajtandó művelet típusát állítja. Hatás: kamera/gimbal/repülési műveletek futása az adott ponton.',
    'action.edit_custom_text': 'Egyedi akció szöveg szerkesztése',
    'action.edit_custom_param': 'Egyedi akció paraméter szerkesztése',
    'action.kmz.reachpoint_auto_index_tooltip': 'reachPoint trigger esetén automatikus waypoint index',
    'action.kmz.reachpoint_auto_index_note': 'reachPoint trigger: a startIndex és endIndex automatikus.',
    'action.kmz.group_presets': 'Presets',
    'action.kmz.groups_title': 'KMZ akciócsoportok',
    'action.kmz.group_add': '+ group',
    'action.kmz.group_label': 'Group {n}',
    'action.kmz.start_index': 'startIndex',
    'action.kmz.end_index': 'endIndex',
    'action.kmz.group_mode': 'groupMode',
    'action.kmz.trigger_type': 'triggerType',
    'action.kmz.trigger_custom': 'custom triggerType',
    'action.kmz.trigger_fields': 'trigger fields',
    'action.kmz.trigger_field_add': '+ field',
    'action.kmz.trigger_field_none': 'No extra trigger field.',
    'action.set_value_to': 'Beállítja az értéket erre: {value}',
    'action.type_set_to': 'Beállítja az akció típusát erre: {value}',
    'ui.clear_on_save': 'Érték törlése mentéskor',
    'ui.edit_raw_unix': 'Nyers UNIX időbélyeg szerkesztése',
    'ui.no_displayable_data': 'Nincs megjeleníthető adat.',

    'bulk.title': 'Tömeges szerkesztés ({count})',
    'bulk.apply': 'Alkalmaz',
    'bulk.progress_idle': 'Nincs futó átírás.',
    'bulk.progress_running': 'Pontok frissítése: {current}/{total} ({percent}%).',
    'bulk.progress_done': 'Pontok frissítése kész: {current}/{total} ({percent}%).',
    'bulk.unsaved_changes_title': 'Változtatás történt!',
    'bulk.unsaved_changes_text': 'Biztos hogy mentés nélkül kilép?',
    'bulk.unsaved_changes_confirm': 'Bezárás mentés nélkül',

    'geotiff.library_missing': 'A GeoTIFF könyvtár nem tölthető be.',
    'geotiff.only_tif': 'Csak .tif / .tiff fájl importálható.',
    'geotiff.unsupported_mime': 'Nem támogatott MIME típus: {mime}',
    'geotiff.big_warning': 'A 3 GB feletti TIFF betöltése böngészőben nem stabil. Javasolt COG/tile szerveres megoldás.',
    'geotiff.template_missing': 'A GeoTIFF betöltési minta nem található.',
    'geotiff.loading': 'GeoTIFF betöltése...',
    'geotiff.cache_check': 'Cache ellenőrzése...',
    'geotiff.reading': 'Beolvasás: {percent}%',
    'geotiff.cache_hit_read_skip': 'Cache találat: beolvasás kihagyva',
    'geotiff.cache_hit_parse_skip': 'Parse cache találat: feldolgozás kihagyva',
    'geotiff.phase_parse': 'Raster feldolgozás',
    'geotiff.phase_cache_store': 'Cache mentése',
    'geotiff.phase_create_layer': 'Réteg létrehozása',
    'geotiff.loaded': 'GeoTIFF betöltve',
    'geotiff.detail_large_file': 'Nagy fájl: lassabb renderelés várható.',
    'geotiff.detail_size': 'Méret: {width} x {height} px',
    'geotiff.detail_sampling': 'Mintavételezés: {resolution}',
    'geotiff.detail_source_cache': 'Forrás: cache',
    'geotiff.detail_source_file': 'Forrás: fájl',
    'geotiff.detail_parse_cache': 'Parse: memória cache',
    'geotiff.detail_parse_fresh': 'Parse: új feldolgozás',
    'geotiff.server_tile_prepare_start': 'Szerveres csempézés indul...',
    'geotiff.server_tile_prepare_progress': 'Szerveres csempézés folyamatban: {seconds} mp',
    'geotiff.server_tile_prepare_failed': 'Szerveres csempézés sikertelen',
    'geotiff.server_tile_prepare_fallback': 'Visszaállunk helyi betöltésre. Ok: {reason}',
    'geotiff.load_error_ovr': 'GeoTIFF betöltési hiba (.ovr/security). Próbáld meg overview nélküli TIFF-fel vagy COG formátummal.',
    'geotiff.load_failed': 'A GeoTIFF betöltése sikertelen.',
    'geotiff.import_title': 'Import (GeoTIFF)',
    'geotiff.import_dem_title': 'Import TIFF (DEM/DSM)',
    'geotiff.import_ortho_title': 'Import TIFF (Orto)',
    'geotiff.import_ok': 'OK (Betöltés)',
    'geotiff.import_choose_file': 'Válassz TIFF fájlt, vagy használd a korábban betöltöttet.',
    'geotiff.selected_file': 'Kiválasztva: {name}',
    'geotiff.prev_loaded': 'Korábban betöltött: {name}',
    'geotiff.no_selected': 'Nincs kiválasztott TIFF fájl.',
    'geotiff.overlay_dem': 'TIFF DEM/DSM',
    'geotiff.overlay_ortho': 'TIFF Orto',
    'geotiff.recent.section_title': 'Előzmények',
    'geotiff.recent.empty': 'Nincs előzmény',
    'geotiff.recent.select': 'Megnyitás: {name}',
    'geotiff.recent.unload_tooltip': 'Leveszi a térképről az aktív {label} TIFF réteget. Az előzménylistában megmarad, és oldalfrissítés után sem töltődik vissza automatikusan.',
    'geotiff.popup.recent_label': 'Előzmények',
    'geotiff.popup.recent_empty': 'Nincs kiválasztott előzmény',
    'geotiff.popup.recent_invalid': 'Az előzmény már nem érhető el. Válassz új fájlt.',
    'geotiff.popup.local_file_notice': 'A GeoTIFF fájl helyi fájlból olvasható be (nem kerül szerverre).',
    'geotiff.popup.mode_label': 'Import mód',
    'geotiff.popup.mode_auto': 'Auto (ajánlott)',
    'geotiff.popup.mode_terrain': 'DEM/DSM (magasságforrás)',
    'geotiff.popup.mode_ortho': 'Orto (vizuális overlay)',
    'geotiff.popup.mode_auto_help': 'Auto módban a rendszer megpróbálja felismerni, hogy ortó vagy DEM/DSM raszterről van szó.',
    'geotiff.popup.auto_align': 'Betöltött DEM/DSM adatok automatikus illesztése',
    'geotiff.popup.auto_align_help': 'Ha kikapcsolod, a rendszer a TIFF nyers magasságadatait használja korrekció nélkül.',
    'geotiff.popup.resolution_label': 'Mintavételezés (felbontás, px/tile)',
    'geotiff.popup.resolution_help': 'Alacsonyabb érték gyorsabb, magasabb élesebb.',
    'geotiff.popup.recommended': 'Ajánlott',
    'geotiff.popup.memory_read_notice': 'A fájl helyi memóriából kerül beolvasásra.',
    'geotiff.popup.read_starting': 'Beolvasás indul...',

    'export.no_data': 'Nincs exportálható adat.',
    'export.kml_label': 'Export (KML)',
    'export.kmz_label': 'Export (KMZ)',
    'export.kmz_missing_jszip': 'A KMZ exporthez hiányzik a JSZip.',
    'export.kmz_missing_waylines': 'A KMZ exporthez hiányzik a waylines WPML.',
    'export.kmz_failed': 'A KMZ export sikertelen.',
    'export.progress_title_kml': 'KML export',
    'export.progress_title_kmz': 'KMZ export',
    'export.progress_prepare': 'Export előkészítése',
    'export.progress_points': 'Waypointok szinkronizálása: {current}/{total} ({percent}%).',
    'export.progress_normalize_kmz': 'KMZ normalizálás',
    'export.progress_build_zip': 'KMZ csomag készítése',
    'export.progress_serialize': 'KML szerializálás',
    'export.progress_done': 'Export kész',
    'export.progress_failed': 'Export sikertelen',
    'export.failed': 'Az export sikertelen.',
    'export.shadow_missing_variant': 'A kért árnyék útvonal nem létezik.',

    'route3d.need_two_points': 'A 3D nézethez legalább 2 waypoint szükséges.',
    'route3d.viewer.page_title': 'Útvonal 3D nézet',
    'route3d.viewer.basemap_label': 'Térképforrás',
    'route3d.viewer.basemap.satellite_google': 'Műhold (Google)',
    'route3d.viewer.basemap.satellite_esri': 'Műhold (Esri)',
    'route3d.viewer.basemap.satellite_usgs': 'Műhold (USGS)',
    'route3d.viewer.basemap.street': 'Utca',
    'route3d.viewer.camera_label': 'Kamera:',
    'route3d.viewer.camera.low': 'Alacsony',
    'route3d.viewer.camera.medium': 'Közepes',
    'route3d.viewer.camera.high': 'Magas',
    'route3d.viewer.help_button_title': '3D vezérlés súgó',
    'route3d.viewer.help.title': 'Vezérlés',
    'route3d.viewer.help.rotate': 'Bal egér: forgatás térben',
    'route3d.viewer.help.tilt': 'Jobb egér vagy Ctrl+bal: döntés/elforgatás',
    'route3d.viewer.help.zoom': 'Görgő: zoom',
    'route3d.viewer.help.pan': 'Középső gomb húzás: eltolás',
    'route3d.viewer.help.mobile': 'Mobilon: 1 ujjas húzás forgatás, 2 ujjas csippentés zoom.',
    'route3d.viewer.button.timeline': 'Idővonal',
    'route3d.viewer.button.focus_route': 'Útvonalra fókusz',
    'route3d.viewer.button.zoom_in': 'Közelebb',
    'route3d.viewer.button.zoom_out': 'Távolabb',
    'route3d.viewer.button.rotate_left': 'Forgatás balra',
    'route3d.viewer.button.rotate_right': 'Forgatás jobbra',
    'route3d.viewer.button.tilt_up': 'Döntés fel',
    'route3d.viewer.button.tilt_down': 'Döntés le',
    'route3d.viewer.button.move_left': 'Mozgatás balra',
    'route3d.viewer.button.move_right': 'Mozgatás jobbra',
    'route3d.viewer.button.move_up': 'Mozgatás fel',
    'route3d.viewer.button.move_down': 'Mozgatás le',
    'route3d.viewer.button.reset_north': 'Északra igazít',
    'route3d.viewer.button.drone_follow': 'Drón követése',
    'route3d.viewer.speed.slower': 'Lassabb',
    'route3d.viewer.speed.faster': 'Gyorsabb',
    'route3d.speed.label': 'Sebesség',
    'route3d.speed.unit_mps': 'm/s',
    'route3d.speed.tooltip.trigger_aria': 'Sebesség feloldás részletei',
    'route3d.speed.tooltip.title': 'Sebesség feloldás',
    'route3d.speed.tooltip.active_segment': 'Aktív szakasz',
    'route3d.speed.tooltip.point_source': 'Pontforrás',
    'route3d.speed.tooltip.segment_rule': 'Szakasz szabály',
    'route3d.speed.tooltip.kmz_playback': 'KMZ playback',
    'route3d.speed.tooltip.template_use_global': 't.useGlobalSpeed',
    'route3d.speed.tooltip.template_waypoint_speed': 't.waypointSpeed',
    'route3d.speed.tooltip.template_auto_flight_speed': 't.autoFlightSpeed',
    'route3d.speed.tooltip.waylines_use_global': 'w.useGlobalSpeed',
    'route3d.speed.tooltip.waylines_waypoint_speed': 'w.waypointSpeed',
    'route3d.speed.tooltip.waylines_auto_flight_speed': 'w.autoFlightSpeed',
    'route3d.speed.tooltip.resolved_project_speed': 'Kék érték',
    'route3d.speed.tooltip.multiplier': 'Lejátszási szorzó',
    'route3d.speed.tooltip.actual_speed': 'Sárga érték',
    'route3d.speed.tooltip.why': 'Miért',
    'route3d.speed.tooltip.none': '--',
    'route3d.speed.tooltip.segment_rule_value': 'célpont -> forráspont -> küldetés alap',
    'route3d.speed.tooltip.kmz_rule_value': 'waylines -> template -> default',
    'route3d.speed.tooltip.scope.template': 'template',
    'route3d.speed.tooltip.scope.waylines': 'waylines',
    'route3d.speed.tooltip.scope.point': 'point.props',
    'route3d.speed.tooltip.scope.default': 'default',
    'route3d.speed.tooltip.window.active': 'aktív',
    'route3d.speed.tooltip.window.upcoming': 'következő',
    'route3d.speed.tooltip.window.previous': 'előző',
    'route3d.speed.tooltip.source.to': 'célpont',
    'route3d.speed.tooltip.source.from': 'forráspont',
    'route3d.speed.tooltip.source.base': 'küldetés alap',
    'route3d.speed.tooltip.source.payload_mission': 'payload missionSpeedMps',
    'route3d.speed.tooltip.source.first_point': 'első elérhető pontsebesség',
    'route3d.speed.tooltip.source.viewer_default': 'viewer default 8 m/s',
    'route3d.speed.tooltip.reason.to': 'Az aktív szakaszon a célpont sebessége érvényes.',
    'route3d.speed.tooltip.reason.from': 'A célpontnál nincs használható speed, ezért a forráspont sebessége érvényes.',
    'route3d.speed.tooltip.reason.base': 'Az aktív szakaszon nincs pontszintű speed, ezért a küldetés alapsebessége érvényes.',
    'route3d.speed.tooltip.reason.segment.from_prefix': 'A célpontnál nincs használható sebesség, ezért a forráspont feloldása számít.',
    'route3d.speed.tooltip.reason.local': 'A {useGlobalPath}={useGlobalValue}, ezért a helyi {resolvedPath}={resolvedValue} aktív.',
    'route3d.speed.tooltip.reason.global': 'A {useGlobalPath}={useGlobalValue}, ezért a globális {resolvedPath}={resolvedValue} aktív.',
    'route3d.speed.tooltip.reason.global_local_ignored': 'A {useGlobalPath}={useGlobalValue}, ezért a globális {resolvedPath}={resolvedValue} az aktív. A helyi waypointSpeed ilyenkor nem érvényes.',
    'route3d.speed.tooltip.reason.global_fallback_local': 'A {useGlobalPath}={useGlobalValue}, de nincs használható autoFlightSpeed, ezért a helyi {resolvedPath}={resolvedValue} lett aktív.',
    'route3d.speed.tooltip.reason.local_fallback_global': 'A {useGlobalPath}={useGlobalValue}, de nincs használható waypointSpeed, ezért a globális {resolvedPath}={resolvedValue} lett aktív.',
    'route3d.speed.tooltip.reason.unspecified_local': 'A waylines -> template -> default szabály alapján a helyi {resolvedPath}={resolvedValue} lett aktív.',
    'route3d.speed.tooltip.reason.unspecified_global': 'A waylines -> template -> default szabály alapján a globális {resolvedPath}={resolvedValue} lett aktív.',
    'route3d.speed.tooltip.reason.direct_speed_mps': 'Az aktív pont közvetlen {resolvedPath}={resolvedValue} értéke érvényes.',
    'route3d.speed.tooltip.reason.direct_speed': 'Az aktív pont közvetlen {resolvedPath}={resolvedValue} értéke érvényes.',
    'route3d.speed.tooltip.reason.default.payload_mission': 'Nincs használható pont- vagy scope-adat, ezért a küldetés alapsebessége {resolvedValue} lép életbe.',
    'route3d.speed.tooltip.reason.default.first_point': 'Az aktív szakaszon nincs használható pont- vagy scope-adat, ezért az első elérhető pontsebesség {resolvedValue} szolgál alapsebességként.',
    'route3d.speed.tooltip.reason.default.viewer_default': 'Nincs használható pont- vagy scope-adat, ezért a viewer default {resolvedValue} lép életbe.',
    'route3d.speed.tooltip.reason.default.generic': 'Nincs használható pont- vagy scope-adat, ezért a {sourceLabel} forrás {resolvedValue} értéke lép életbe.',
    'route3d.speed.tooltip.reason.scope_priority_waylines': 'A playbacknél a waylines scope erősebb a template scope-nál.',
    'route3d.speed.tooltip.decision.global': 'useGlobalSpeed=true -> autoFlightSpeed',
    'route3d.speed.tooltip.decision.globalFallbackLocal': 'useGlobalSpeed=true, nincs autoFlightSpeed -> waypointSpeed',
    'route3d.speed.tooltip.decision.local': 'useGlobalSpeed=false -> waypointSpeed',
    'route3d.speed.tooltip.decision.localFallbackGlobal': 'useGlobalSpeed=false, nincs waypointSpeed -> autoFlightSpeed',
    'route3d.speed.tooltip.decision.unspecifiedLocal': 'useGlobalSpeed nincs megadva -> waypointSpeed',
    'route3d.speed.tooltip.decision.unspecifiedGlobal': 'useGlobalSpeed nincs megadva -> autoFlightSpeed',
    'route3d.speed.tooltip.decision.directSpeedMps': 'point.props.speedMps',
    'route3d.speed.tooltip.decision.directSpeed': 'point.props.speed',
    'route3d.speed.tooltip.decision.default': 'nincs projekt speed -> viewer default',
    'route3d.speed.tooltip.not_kmz': 'Nem KMZ speed resolver',
    'route3d.viewer.timeline_zoom_in': 'Idővonal nagyítása',
    'route3d.viewer.timeline_zoom_out': 'Idővonal kicsinyítése',
    'route3d.viewer.timeline_aria': 'AGL-idővonal',
    'route3d.actions.past': 'Múlt',
    'route3d.actions.current': 'Jelen',
    'route3d.actions.future': 'Jövő',
    'route3d.actions.none': 'Nincs akció',
    'route3d.actions.tooltip.trigger': 'Trigger',
    'route3d.actions.tooltip.range': 'Tartomány',
    'route3d.actions.tooltip.settings': 'Beállítások',
    'route3d.actions.tooltip.settings_none': 'Nincs külön beállítás.',
    'route3d.actions.trigger.reach_point': 'Waypoint elérése',
    'route3d.actions.trigger.between_points': 'Két pont között',
    'route3d.actions.trigger.multiple_timing': 'Időzített',
    'route3d.actions.label.gimbalRotate': 'Gimbal forgatás',
    'route3d.actions.label.gimbalEvenlyRotate': 'Gimbal átforgatás',
    'route3d.actions.label.focus': 'Fókusz',
    'route3d.actions.label.takePhoto': 'Fotó',
    'route3d.actions.label.orientedShoot': 'Irányított felvétel',
    'route3d.actions.label.startRecord': 'Videó indítás',
    'route3d.actions.label.stopRecord': 'Videó leállítás',
    'route3d.actions.label.zoom': 'Zoom',
    'route3d.actions.label.customDirName': 'Könyvtárnév',
    'route3d.actions.label.hover': 'Lebegés',
    'route3d.actions.label.rotateYaw': 'Yaw forgatás',
    'route3d.heading.badge': 'Yaw',
    'route3d.heading.mode.followWayline': 'Útvonal',
    'route3d.heading.mode.manually': 'Kézi',
    'route3d.heading.mode.fixed': 'Fix',
    'route3d.heading.mode.smoothTransition': 'Átmenet',
    'route3d.heading.mode.towardPOI': 'POI',
    'route3d.heading.path_mode.followBadArc': 'Rövid ív',
    'route3d.heading.path_mode.clockwise': 'Óra szerint',
    'route3d.heading.path_mode.counterClockwise': 'Óra ellen',
    'route3d.heading.tooltip.title': 'Yaw / heading',
    'route3d.heading.tooltip.mode': 'Mód',
    'route3d.heading.tooltip.angle': 'Szög',
    'route3d.heading.tooltip.path_mode': 'Ív',
    'route3d.heading.tooltip.poi': 'POI',
    'route3d.layout.source_map_error_pattern': 'Forrástérkép hiba',
    'center.no_open_mission': 'Nincs megnyitott KML/KMZ a középre igazításhoz.',
    'center.bounds_unavailable': 'A KML/KMZ határai nem számolhatók.',

    'new_kml.template_missing': 'A KML minta nem található.',
    'new_kml.need_two_points': 'A KML minta legalább 2 waypointot igényel.',
    'new_kml.failed': 'Az új KML létrehozása sikertelen.',
    'new_kmz.templates_missing': 'A KMZ mintafájlok nem találhatók.',
    'new_kmz.need_two_points': 'A KMZ minta legalább 2 waypointot igényel.',
    'new_kmz.failed': 'Az új KMZ létrehozása sikertelen.',

    'import.title': 'Import (KML/KMZ)',
    'import.convert_to_kmz_project': 'Betöltött adatok konvertálása KMZ projektként',
    'import.unsupported_type': 'A típus nem támogatott!',
    'import.file_too_large': 'A {type} fájl túl nagy. Maximum: {maxMb} MB.',
    'import.kmz_missing_jszip': 'A KMZ importhoz hiányzik a JSZip.',
    'import.kmz_templates_missing': 'A KMZ mintaállományok nem találhatók.',
    'import.kmz_parse_failed': 'A KMZ fájl feldolgozása sikertelen.',
    'import.invalid_kml': 'A fájl nem érvényes KML formátumú.',
    'import.file_process_failed': 'A fájl feldolgozása sikertelen.',
    'import.progress_title': 'KML/KMZ import',
    'import.progress_read_kmz': 'KMZ fájl olvasása',
    'import.progress_open_zip': 'KMZ csomag megnyitása',
    'import.progress_extract_xml': 'template.kml és waylines.wpml kinyerése',
    'import.progress_parse_xml': 'XML feldolgozása',
    'import.progress_waypoints': 'Waypointok feldolgozása: {current}/{total} ({percent}%).',
    'import.progress_convert_kmz': 'KML konvertálása KMZ projektté',
    'import.progress_render': 'Importált útvonal betöltése',
    'import.progress_done': 'Import kész',
    'import.progress_failed': 'Import sikertelen',

    'close.no_edited_route': 'Nincs szerkesztett útvonal.',
    'close.confirm': 'Biztos, hogy bezárja a szerkesztett útvonalat, mentés nélkül?',
    'close.delete_title': 'Útvonal törlés megerősítése',
    'close.delete_text': 'A következő útvonal(ak) törlésre kerül(nek): {variants}.',
    'close.delete_irreversible': 'Ez a művelet nem visszavonható.',
    'close.delete_confirm': 'Törlés',

    'divide.no_enough_points': 'Nincs elég pont az osztáshoz.',
    'divide.select_two_points': 'Jelölj ki legalább 2 pontot.',
    'divide.no_valid_segment': 'A kijelölt pontok között nincs érvényes szakasz.',
    'divide.title': 'Pont elosztás',
    'divide.no_removable_midpoints': 'Nincs törölhető köztes pont a kijelölt szakaszon.',
    'divide.height_calc_straight': 'Egyenes vonalban',
    'divide.height_calc_surface_follow_prefix': 'Felszín követés - ',
    'divide.popup.selected_count': 'Kijelölt pontok száma: __SELECTED_COUNT__ (szomszédos kijelölt pontpárokra alkalmazva)',
    'divide.popup.segment_rule': 'Csak akkor oszt, ha egy szakasz hossza nagyobb, mint a távolság kétszerese.',
    'divide.popup.max_distance': 'Legnagyobb távolság (m)',
    'divide.popup.heading_only': 'Csak a kamera irányának megfelelően!',
    'divide.popup.heading_threshold': 'Küszöbérték (fok)',
    'divide.popup.distance': 'Távolság (m)',
    'divide.popup.count': 'Darabszám',
    'divide.popup.height_calc': 'Magasság kiszámítása',
    'divide.popup.remainder': 'Eloszlás maradéka',
    'divide.popup.remainder_aria': 'Eloszlás maradéka',
    'divide.popup.remainder_start': 'Kezdőpont felőli oldalon',
    'divide.popup.remainder_center': 'Közepes eloszlás',
    'divide.popup.remainder_end': 'Végpont felőli oldalon',
    'divide.popup.remove_inserted': 'Köztes pontok eltávolítása (P-)',
    'divide.progress_prepare': 'Szakaszok elemzése',
    'divide.progress_fetch_surface': 'Felszínminták lekérése',
    'divide.progress_insert': 'Köztes pontok beszúrása',
    'divide.progress_finalize': 'Útvonal frissítése',
    'divide.progress_done': 'Pont elosztása kész',
    'kmz.scope.template_only': 'Export scope: csak a template.kml fájlba kerül.',
    'kmz.scope.waylines_only': 'Export scope: csak a waylines.wpml fájlba kerül.',
    'kmz.scope.both': 'Export scope: a template.kml és a waylines.wpml fájlba is kerül.',
    'kmz.scope.none': 'Export scope: egyik KMZ fájlba sem kerül.',
    'kmz.scope.unresolved': 'Export scope: nem egyértelmű, fallbackként mindkét oldalon megtartható.',
    'kmz.scope.layer_template': 'A template.kml a tervezési réteg.',
    'kmz.scope.layer_waylines': 'A waylines.wpml a megvalósítási réteg.',
    'kmz.scope.legend_template': 'Sárga: csak a template.kml oldalon szerepel.',
    'kmz.scope.legend_waylines': 'Kék: csak a waylines.wpml oldalon szerepel.',
    'kmz.scope.legend_both': 'Zöld: mindkét rétegben szerepel.',
    'kmz.scope.legend_none': 'Fekete: egyik rétegben sem kanonikus / nem exportált mező.',
    'kmz.scope.legend_unresolved': 'Magenta: a scope nem egyértelmű, fallback / ismeretlen.',
    'kmz.scope.table.layer_template_marker': 'template.kml',
    'kmz.scope.table.layer_template_detail': '(tervezési réteg)',
    'kmz.scope.table.layer_waylines_marker': 'waylines.wpml',
    'kmz.scope.table.layer_waylines_detail': '(megvalósítási réteg)',
    'kmz.scope.table.template_marker': 'Sárga',
    'kmz.scope.table.template_meaning': 'Csak a template.kml oldalon szerepel.',
    'kmz.scope.table.waylines_marker': 'Kék',
    'kmz.scope.table.waylines_meaning': 'Csak a waylines.wpml oldalon szerepel.',
    'kmz.scope.table.both_marker': 'Zöld',
    'kmz.scope.table.both_meaning': 'Mindkét rétegben szerepel.',
    'kmz.scope.table.none_marker': 'Fekete',
    'kmz.scope.table.none_meaning': 'Egyik rétegben sem kanonikus / nem exportált mező.',
    'kmz.scope.table.unresolved_marker': 'Magenta',
    'kmz.scope.table.unresolved_meaning': 'A scope nem egyértelmű.',

    'altitude.no_processable_point': 'Nincs feldolgozható pont.',
    'altitude.popup_template_missing': 'Hiányzik a funkció popup sablon.',
    'altitude.title': 'Magasság',

    'seek.no_movable_point': 'Nincs eltolható pont.',
    'seek.redraw_axis_title': 'Rajzold újra a tengelyt két ponttal.',
    'seek.axis_need_two_points': 'Az eltolás tengelyéhez legalább 2 pontból álló vonal kell.',
    'seek.auto_axis_unknown': 'Az automatikus tengely iránya nem meghatározható.',
    'seek.no_selected_row': 'Nincs kiválasztott sor.',
    'seek.selected_row': 'Kijelölt sor: #{from} - #{to} ({type}, {distance} m)',
    'seek.row_type_long': 'hosszú',
    'seek.row_type_short': 'rövid',
    'seek.title': 'Pontok eltolása / Sor klónozás',
    'seek.redraw_axis': 'Tengely megrajzolása kézzel',
    'seek.axis_not_computable': 'Az automatikus tengely nem számolható. Rajzold meg kézzel.',
    'seek.grid_unavailable': 'A rács iránya most nem érhető el.',
    'seek.rotate_to_grid': 'Tengely igazítása a rácshoz',
    'seek.rotate_center_tooltip': 'Forgatás középpontja, ez mozgatható.',
    'seek.popup.rotate_deg': 'Forgatás (fok)',
    'seek.popup.rotate_left': 'Forgatás balra',
    'seek.popup.rotate_right': 'Forgatás jobbra',
    'seek.popup.offset_m': 'Eltolás (m)',
    'seek.popup.offset_left_down': 'Eltolás balra le',
    'seek.popup.offset_right_up': 'Eltolás jobbra fel',
    'seek.popup.clone_distance_m': 'Klónozás távolság (m)',
    'seek.popup.select_first_row': 'Első sor kiválasztása',
    'seek.popup.select_last_row': 'Utolsó sor kiválasztása',
    'seek.popup.clone_toward_first_row': 'Első sor felé klónozás',
    'seek.popup.clone_toward_last_row': 'Utolsó sor felé klónozás',
    'seek.popup.axis_split_auto_detect': 'Tengely rajzolásnál a felosztott sorok automatikus felismerése.',
    'grid.overlay_label': 'Rács',
    'grid.modal_title': 'Rács beállítások',
    'grid.width_label': 'Szélesség (m)',
    'grid.height_label': 'Hosszúság (m)',
    'grid.rotation_label': 'Dőlésszög (fok)',
    'grid.min_zoom_label': 'Min zoom',
    'grid.max_zoom_label': 'Max zoom',
    'grid.shift_step_meters_label': 'Eltolás (m)',
    'grid.rotate_step_deg_label': 'Forgatás lépés (°)',
    'grid.shift_left': 'Balra',
    'grid.shift_right': 'Jobbra',
    'grid.shift_up': 'Fel',
    'grid.shift_down': 'Le',
    'grid.rotate_left': 'Forgatás balra',
    'grid.rotate_right': 'Forgatás jobbra',
    'grid.fit_waypoints': 'Útpontokhoz igazítás',
    'grid.fit_status_idle': 'Legalább 4 pontból álló, legalább 1 m-es, szabályos eloszlású útpontsorhoz igazítja a rácsot.',
    'grid.fit_success': 'Rács igazítva: {pointCount} pont, {segmentCount} szakasz, {spacingMeters} m osztás, {residualMeters} m átlagos maradék.',
    'grid.fit_error_no_waypoints': 'Nincs betöltött útvonal az igazításhoz.',
    'grid.fit_error_need_four_points': 'Az igazításhoz legalább 4 érvényes útpont kell.',
    'grid.fit_error_spacing_too_small': 'Az automatikus igazítás csak legalább 1 m-es ponttávolságnál engedélyezett.',
    'grid.fit_error_no_regular_distribution': 'Nem találtam elég szabályos, azonos osztású útpontsor-szakaszt.',
    'grid.fit_error_majority': 'Az útpontok többsége nem esik ugyanabba a szabályos osztásba, ezért a rács nem igazítható biztosan.',
    'grid.fit_error_residual': 'Találtam jelölt osztást, de az illesztési maradék túl nagy maradt, ezért nem állítottam át a rácsot.',
    'grid.shift_keyboard_help': 'Mozgatás: nyilak vagy W/A/S/D. Forgatás: Q/E.',
    'grid.offset_x_label': 'X',
    'grid.offset_y_label': 'Y',
    'grid.overlay_zoom_visible': 'A rács látható. A zoom szint ({currentZoom}) megfelelő: {minZoom} - {maxZoom}.',
    'grid.overlay_zoom_too_low': 'A rács NEM látható. A zoom szint ({currentZoom}) túl alacsony: {minZoom} - {maxZoom}.',
    'grid.overlay_zoom_too_high': 'A rács NEM látható. A zoom szint ({currentZoom}) túl magas: {minZoom} - {maxZoom}.',
    'grid.overlay_zoom_disabled': 'A rács overlay jelenleg ki van kapcsolva. A zoom szint ({currentZoom}): {minZoom} - {maxZoom}.',
    'shadow.title': 'Árnyékútvonal létrehozása',
    'shadow.switch_left': 'Átváltás bal útvonalra',
    'shadow.switch_right': 'Átváltás jobb útvonalra',
    'shadow.switch_next': 'Következő árnyék útvonal kiválasztása',
    'shadow.gimbal_pitch_label': 'GSZ (fok)',
    'shadow.mode_label': 'Mód',
    'shadow.mode_auto': 'AUTO',
    'shadow.mode_manual': 'MANUAL',
    'shadow.row_spacing_label': 'ST (m)',
    'shadow.row_height_label': 'SM (m)',
    'shadow.vfov_label': 'VFOV (fok)',
    'shadow.target_rows_label': 'sorok',
    'shadow.gm_label': 'GM (m)',
    'shadow.do_label': 'D-O (m)',
    'shadow.left_gimbal_label': 'ls.gimbalPitchAngle',
    'shadow.right_gimbal_label': 'rs.gimbalPitchAngle',
    'shadow.project_height_label': 'project.height',
    'shadow.preview_aria': 'Árnyék útvonal oldalnézeti előnézet',
    'shadow.photo_preview_aria': 'Árnyék útvonal fotó-nézeti előnézet',
    'shadow.calc_title': 'Részszámítás',
    'shadow.calc_axis_up_bearing': 'Tengely irány (fok)',
    'shadow.calc_left_abs_pitch': 'Bal |gimbalPitchAngle| (fok)',
    'shadow.calc_left_tan': 'Bal tan(|szög|)',
    'shadow.calc_left_offset': 'Bal vízszintes távolság (m)',
    'shadow.calc_right_abs_pitch': 'Jobb |gimbalPitchAngle| (fok)',
    'shadow.calc_right_tan': 'Jobb tan(|szög|)',
    'shadow.calc_right_offset': 'Jobb vízszintes távolság (m)',
    'shadow.calc_drone_center_row_distance': 'D-O (m)',
    'shadow.calc_near_ground_intersection': 'F1-O (m)',
    'shadow.calc_far_ground_intersection': 'O-F2 (m)',
    'shadow.calc_ground_span': 'F1-F2 (m)',
    'shadow.tooltip.gimbal_pitch': 'Gimbal (drón) dőlésszög a vízszinteshez képest (0° = vízszintes, -90° = lefelé).',
    'shadow.tooltip.mode': 'AUTO módban a program optimalizál, MANUAL módban a GM és D-O kézzel állítható.',
    'shadow.tooltip.row_spacing': 'Sorok közötti átlagos távolság (st), méterben.',
    'shadow.tooltip.row_height': 'Sormagasság (sm), méterben.',
    'shadow.tooltip.vfov': 'A kamera vertikális látószöge (vfov), fokban.',
    'shadow.tooltip.target_rows': 'Egyszerre teljesen lefotózni kívánt központi sorok száma.',
    'shadow.tooltip.gm': 'Gimbal (drón) magasság a talajszinthez képest, méterben.',
    'shadow.tooltip.do': 'A drón (D) és a vetületi középpont (O) vízszintes távolsága, méterben.',
    'shadow.tooltip.calc_axis_up_bearing': 'A térképi tengely iránya (yaw/azimuth), fokban.',
    'shadow.tooltip.calc_drone_center_row_distance': 'Az eredeti és új útvonal eltolásának mértéke: a drón és az O pont vízszintes távolsága.',
    'shadow.tooltip.calc_near_ground_intersection': 'A látómező közeli szélső sugara hol metszi a talajt az origóhoz képest.',
    'shadow.tooltip.calc_far_ground_intersection': 'A látómező távoli szélső sugara hol metszi a talajt az origóhoz képest.',
    'shadow.tooltip.calc_ground_span': 'A közeli és távoli földmetszet távolsága, vagyis a földi képszélesség.',
    'shadow.height_warning': 'Figyelem! A project.height érték nem azonos minden pontban!',
    'shadow.row_spacing_warning': 'A sortávolság nem határozható meg biztosan az útvonalból, ezért alapértékre állt.',
    'shadow.draw_axis_manual': 'Tengely megrajzolása kézzel',
    'shadow.action_left': 'B',
    'shadow.action_right': 'J',
    'shadow.action_both': 'BJ',
    'shadow.action_cancel': 'Mégse',
    'shadow.no_project_height': 'Nincs használható project.height érték.',
    'shadow.invalid_pitch': 'A gsz értéke nem lehet 0 fok.',
    'shadow.invalid_gm': 'A gm érték nem számolható a megadott paraméterekkel.',
    'shadow.invalid_axis': 'Az árnyék tengely iránya nem meghatározható.',
    'shadow.created_left': 'Bal árnyék útvonal létrehozva.',
    'shadow.created_right': 'Jobb árnyék útvonal létrehozva.',
    'shadow.created_both': 'Bal és jobb árnyék útvonal létrehozva.',

    'info.title': 'Verziók és changelog',
    'info.tab_about': 'Névjegy, Change log',
    'info.tab_versions': 'Térkép forrás verziók',
    'info.update_available': 'Új verzió érhető el',
    'info.refresh_hint': 'Érdemes frissíteni az oldalt. A részletek az Info gomb alatt olvashatók.',
    'info.version_endpoint_error': 'Verzió endpoint hiba',
    'info.electron_version_mismatch_title': 'Electron app frissítés javasolt',
    'info.electron_version_mismatch_text': 'Az Electron app verziója ({electronVersion}) eltér a webapp verziójától ({webVersion}). Érdemes frissíteni az Electron appot.',
    'info.electron_update_available_title': 'Új verzió letöltése',
    'info.electron_update_downloading': 'A(z) {version} verzió letöltése folyamatban...',
    'info.electron_update_ready_title': 'Frissítés kész',
    'info.electron_update_ready_text': 'A(z) {version} verzió letöltve és telepítésre kész.',
    'info.electron_update_not_available_title': 'Frissítés ellenőrizve',
    'info.electron_update_not_available_text': 'Jelenleg nincs új verzió.',
    'info.electron_update_install': 'Újraindítás és telepítés',
    'info.electron_update_later': 'Később',
    'info.electron_download_manifest_error': 'A latest.yml letöltése sikertelen',
    'info.electron_download_missing_file': 'A latest.yml nem tartalmaz telepítő fájlt',
    'info.electron_download_failed': 'A legújabb Electron telepítő letöltése most nem sikerült. Próbáld újra később.',
    'log.electron_download_error': 'Electron letöltési hiba',
    'map_elevation.settings_title': 'Beállítások - térkép magasság szolgáltató',
    'map_elevation.settings_template_missing': 'Hiányzik a térkép magasság beállítás sablon.',
    'map_elevation.settings_remote_toggle_label': 'Kurzor alatt a magasságértékek megjelenítése',
    'map_elevation.settings_local_toggle_label': 'Kurzor alatt Local DEM/DSM magasságérték megjelenítése',
    'map_elevation.settings_grid_snap_toggle_label': 'Rácshoz igazítás kézi pontfelvételnél',
    'map_elevation.settings_provider_label': 'Elsődleges magasság szolgáltató',
    'map_elevation.settings_fallback_provider_label': 'Fallback magasság szolgáltató',
    'map_elevation.settings_help': 'Kurzor alatti terepmagasság lekéréséhez.',
    'map_elevation.settings_fallback': 'Fallback sorrend: Google -> ArcGIS -> Open-Meteo -> további szolgáltatók.',
    'map_elevation.settings_fallback_help': 'Ha a kurzor kívül esik a betöltött DEM/DSM lefedettségen, ez a szolgáltató adja a magasságot.',
    'map_elevation.settings_grid_snap_help': 'Ha a rács látható, kézi útvonalrajzoláskor a kurzor a közeli rácspontokhoz igazodik.',
    'map_elevation.settings_saved': 'Magasság beállítás mentve',
    'map_elevation.settings_provider_required': 'Válassz szolgáltatót.',
    'map_elevation.settings_fallback_provider_required': 'Válassz fallback szolgáltatót.',
    'map_elevation.cursor_loading': 'Magasság lekérés...',
    'map_elevation.cursor_value': '{provider}: {elevation} m',
    'map_elevation.cursor_error': 'Magasság nem elérhető',
    'map_elevation.provider_switched_title': 'Magasság szolgáltató váltás',
    'map_elevation.provider_switched_text': '{from} -> {to}',

    'readme.unavailable': 'README/changelog nem érhető el.',
    'readme.endpoint_error': 'README endpoint hiba',

    'dem.invalid_altitude': 'Hibás Altitude érték.',
    'dem.altitude_min_agl': 'Az Altitude érték legyen legalább 1 m az AGL újraszámoláshoz.',
    'dem.no_points': 'Nincs pont az aktuális KML-ben.',
    'dem.unknown_provider': 'Ismeretlen DEM szolgáltató.',
    'dem.no_valid_coordinates': 'Nincs érvényes koordinátájú pont.',
    'dem.loading_template_missing': 'Hiányzik a DEM loading sablon.',
    'dem.agl_prefix': 'AGL frissítés - ',
    'dem.surface_prefix': 'Felszín frissítés - ',
    'dem.request_failed': 'DEM lekérés sikertelen.',
    'dem.summary_title': 'DEM összesítés',
    'dem.summary_success_count': 'Sikeres: {ok} / {total}',
    'dem.summary_ok_row': 'OK - {provider} ({label})',
    'dem.summary_failed_count': 'Sikertelen: {failed}',
    'dem.summary_error_row': 'HIBA - {provider} ({label}): {reason}',
    'dem.refresh_ok_agl': '{provider} AGL eredmények frissítve (coordinates.alt, Point.coordinates, description, tooltip).',
    'dem.refresh_ok_desc': '{provider} eredmények frissítve a description és tooltip mezőkben.',
    'dem.no_change': 'Nem érkezett érvényes DEM adat a pontokhoz ({provider}).',
    'dem.progress_start': '{provider} lekérés indul...',
    'dem.popup.loading': 'DEM lekérés folyamatban...',
    'dem.popup.starting': 'Indítás...',

    'map_functions.popup.help': 'Válassz funkciót az aktuális szerkesztett (KML/KMZ) pontokra.',
    'map_functions.popup.fetch_all': 'Pontok felszíni magassága - mindegyik lekérése',
    'map_functions.popup.provider_localdem': 'Pontok felszíni magassága (localDEM) Betöltött DEM/DSM',
    'map_functions.popup.provider_oedem': 'Pontok felszíni magassága (oeDEM) Open-Elevation (~30-90 m)',
    'map_functions.popup.provider_gdem': 'Pontok felszíni magassága (gDEM) Google Elevation (~30 m)',
    'map_functions.popup.provider_otddem': 'Pontok felszíni magassága (otdDEM) OpenTopoData (~90 m)',
    'map_functions.popup.provider_omedem': 'Pontok felszíni magassága (omeDEM) Open-Meteo Elevation (~90 m)',
    'map_functions.popup.provider_arcgisele': 'Pontok felszíni magassága (ArcGIS-Ele) WorldElevation3D (~10-90 m)',

    'validate.distance_positive': 'Adj meg pozitív távolságot.',
    'validate.count_min_1': 'A darabszám legalább 1 legyen.',
    'validate.threshold_min_0': 'A küszöbérték nem lehet negatív.',
    'validate.altitude_number': 'Adj meg érvényes magasságot.',
    'validate.rotation_center_unavailable': 'A forgatási középpont nem érhető el.',
    'validate.offset_direction_unknown': 'Az eltolás iránya nem meghatározható.',
    'validate.clone_distance_positive': 'Adj meg pozitív klónozási távolságot.',
    'validate.select_row': 'Előbb válassz ki egy sort.',
    'validate.clone_row_failed': 'A sor klónozása sikertelen.',
    'validate.invalid_remainder_mode': 'Érvénytelen maradék elosztási mód.',
    'validate.agl_min_1m': 'AGL újraszámoláshoz az Altitude érték legalább 1 m legyen.',
    'validate.positive_rotation_angle': 'Adj meg egy pozitív forgatási szöget.',
    'validate.positive_distance': 'Adj meg egy pozitív távolságot.',
    'validate.kmz_allowed_values': 'Megengedett értékek: {values}',
    'validate.kmz_number_required': 'Számot adj meg.',
    'validate.kmz_minimum': 'Minimum: {min}',
    'validate.kmz_maximum': 'Maximum: {max}',

    'help.no_extra': 'Nincs részletes segítség.',
    'help.no_short': 'Nincs rövid leírás.',
    'copy.failed': 'A másolás nem sikerült.',
    'copy.done': 'Másolva: {value}',
    'layer.import': 'Import',
    'layers.loading_title': 'Térkép betöltése',

    'log.indexeddb_getall_error': 'IndexedDB lekérdezési hiba (getAll)',
    'log.indexeddb_setall_error': 'IndexedDB mentési hiba (setAll)',
    'log.missing_layer': 'Hiányzó térképréteg',
    'log.invalid_coord_array': 'Hibás koordináta tömb',
    'log.indexeddb_draft_delete_error': 'IndexedDB draft törlési hiba',
    'log.indexeddb_draft_save_error': 'IndexedDB draft mentési hiba',
    'log.indexeddb_draft_clear_error': 'IndexedDB draft ürítési hiba',
    'log.template_waypoint_parse_error': 'Template waypoint alapérték feldolgozási hiba',
    'log.generic_error_prefix': 'Hiba:',
    'log.undefined_area': 'Nem definiált terület',
    'log.row_shape_undefined': 'A row.shape nincs definiálva',
    'log.skip_notam_invalid_coords': 'NOTAM kihagyva érvénytelen koordináták miatt',
    'log.version_check_error': 'Verzióellenőrzési hiba',
    'log.portal_test_baseline_missing': 'PORTAL_TEST_VERSION_UPDATE: a baseline verzió még nincs beolvasva. Előbb futtasd: await PORTAL_CHECK_VERSION_NOW()',
    'version.test_suffix': '-teszt',
    'log.geotiff_cache_index_read_error': 'GeoTIFF cache index olvasási hiba',
    'log.geotiff_cache_index_write_error': 'GeoTIFF cache index írási hiba',
    'log.geotiff_cache_load_error': 'GeoTIFF cache betöltési hiba',
    'log.geotiff_cache_store_error': 'GeoTIFF cache tárolási hiba',
    'log.geotiff_import_error': 'GeoTIFF import hiba',
    'log.geotiff_quota_unavailable_fallback': 'GeoTIFF cache kvóta becslés nem érhető el, fallback',
    'log.geotiff_quota_missing_fallback': 'GeoTIFF cache kvóta hiányzik, fallback',
    'log.geotiff_quota_computed': 'GeoTIFF cache kvóta kiszámolva',
    'log.geotiff_quota_estimate_failed_fallback': 'GeoTIFF cache kvóta becslés sikertelen, fallback',
    'log.geotiff_cache_load_skipped': 'GeoTIFF cache betöltés kihagyva',
    'log.geotiff_cache_load_try': 'GeoTIFF cache betöltés próbálkozás',
    'log.geotiff_cache_miss': 'GeoTIFF cache találat nincs',
    'log.geotiff_cache_reason_not_arraybuffer': 'nem ArrayBuffer típus',
    'log.geotiff_cache_hit': 'GeoTIFF cache találat',
    'log.geotiff_cache_store_skipped': 'GeoTIFF cache mentés kihagyva',
    'log.geotiff_cache_store_clone_failed': 'GeoTIFF cache mentés kihagyva: klónozás sikertelen',
    'log.geotiff_cache_store_invalid_signature': 'GeoTIFF cache mentés kihagyva: érvénytelen aláírás/kulcs',
    'log.geotiff_cache_store_size_out_of_range': 'GeoTIFF cache mentés kihagyva: méret tartományon kívül',
    'log.geotiff_cache_store_begin': 'GeoTIFF cache mentés indul',
    'log.geotiff_cache_evict': 'GeoTIFF cache elem törlése (evict)',
    'log.geotiff_cache_store_no_space_after_evict': 'GeoTIFF cache mentés kihagyva: evict után sincs hely',
    'log.geotiff_cache_store_success': 'GeoTIFF cache mentés sikeres',
    'log.geotiff_load_start': 'GeoTIFF betöltés indul',
    'log.geotiff_filereader_cache_miss': 'GeoTIFF FileReader ág (cache miss)',
    'log.geotiff_arraybuffer_cache_hit_skip_filereader': 'GeoTIFF ArrayBuffer cache találat, FileReader kihagyva',
    'log.geotiff_parse_cache_hit_memory': 'GeoTIFF parse cache találat (memória)',
    'log.geotiff_parse_cache_miss': 'GeoTIFF parse cache miss',
    'log.geotiff_parse_completed_main_thread': 'GeoTIFF parse kész (main thread)',
    'log.geotiff_skip_store_already_from_cache': 'GeoTIFF mentés kihagyva: már cache-ből jött',
    'log.dem_elevation_request_error': 'DEM magasság lekérési hiba',
    'log.indexeddb_draft_restore_error': 'IndexedDB draft visszaállítási hiba',
    'log.kmz_export_error': 'KMZ export hiba',
    'log.route3d_indexeddb_write_error': 'Route 3D IndexedDB írási hiba',
    'log.new_kml_create_error': 'Új KML létrehozási hiba',
    'log.new_kmz_create_error': 'Új KMZ létrehozási hiba',
    'log.kmz_import_parse_error': 'KMZ import feldolgozási hiba',
    'log.import_parse_error': 'Import feldolgozási hiba',
    'log.info_payload_load_error': 'Info payload betöltési hiba',
    'log.file_reader_error': 'FileReader hiba',
    'log.geotiff_parse_reason_missing_signature': 'Hiányzó aláírás',
    'log.geotiff_parse_reason_empty_memory_cache': 'Üres memória cache',
    'log.geotiff_parse_reason_signature_mismatch': 'Aláírás eltérés',
    'log.geotiff_parse_reason_missing_georaster': 'Hiányzó georaster objektum',

    'route3d.error.unknown': 'Ismeretlen hiba',
    'route3d.error.dem_fallback': 'A DEM terep nem érhető el, ezért gömbfelszín fallback aktív.',
    'route3d.error.payload_missing': 'A 3D nézet adatai nem találhatók vagy hiányosak. Nyisd meg újra a főablakból.',
    'route3d.error.need_two_points': 'A 3D nézethez legalább 2 érvényes pont szükséges.',
    'route3d.error.init_failed': '3D nézet inicializálási hiba',
    'route3d.toast.route_updated': 'Változás történt, útvonal frissítése megtörtént.',
    'route3d.player.pause': 'Szünet',
    'route3d.player.restart': 'Újra',
    'route3d.player.play': 'Lejátszás',
    'route3d.entity.preview_drone': 'Előnézeti drón',
    'route3d.entity.drone_label': 'Drón',
    'route3d.entity.drone_ray': 'Drón kameravonal',
    'route3d.entity.route_flight': 'Útvonal (repülési magasság)',
    'route3d.entity.route_terrain': 'Útvonal (terep szint)',
    'route3d.timeline.no_data': 'Nincs elég adat az idővonal rajzolásához.',
    'route3d.timeline.flight_short': 'R',
    'route3d.timeline.terrain_short': 'F',
    'route3d.timeline.zero_km': '0 km',
    'route3d.timeline.altitude_axis': 'Magasság (m)',
    'route3d.timeline.flight_label': 'Repülési magasság',
    'route3d.timeline.terrain_label': 'Felszín magasság',
    'route3d.timeline.fallback_label': 'Fallback magasság',
    'route3d.meta.points': 'pontok',
    'route3d.defaults.mission_name': 'küldetés',
    'route3d.defaults.wp_prefix': 'WP',
    'route3d.nav.zoom_in': 'Nagyítás',
    'route3d.nav.zoom_out': 'Kicsinyítés',
    'route3d.nav.reset': 'Alaphelyzet',
    'route3d.nav.tilt': 'Döntés',
    'route3d.nav.rotate': 'Forgatás',
    'route3d.nav.north': 'Északra igazítás',

    'dji.field_prefix': 'DJI/KML mező:',
    'dji.field_influence': 'Hatás: a(z) {field} mező aktuális értéke a küldetés végrehajtását befolyásolja.',
    'dji.field_direct_update': 'DJI/KML mező: {field}. A módosítás a küldetés adatait közvetlenül frissíti.',
    'dji.value_set': 'A(z) {field} mező értéke erre áll: {value}.',
    'dji.parameter_prefix': 'DJI/KML paraméter:',
    'dji.no_description': 'Leírás nincs definiálva ehhez a mezőhöz.',
    'dji.description_prefix': 'Leírás:',
    'dji.values_prefix': 'Értékek:',
    'dji.range_prefix': 'Tartomány:',
    'preset.height_mode.relative_to_start_point': 'A felszállási ponthoz viszonyított.',
    'preset.height_mode.egm96': 'ASL (EGM96) mód.',
    'preset.height_mode.wgs84': 'WGS84 ellipszoid mód.',
    'preset.height_mode.real_time_follow_surface': 'Domborzatkövető mód.',
    'preset.drone_enum.60': 'DJI droneEnumValue: M300 RTK típus.',
    'preset.drone_enum.67': 'DJI droneEnumValue: M30/M30T típus.',
    'preset.drone_enum.77': 'DJI droneEnumValue: M3E/M3T/M3M típus.',
    'preset.drone_enum.89': 'DJI droneEnumValue: M350 RTK típus.',
    'preset.drone_enum.91': 'DJI droneEnumValue: M3D/M3TD típus.',
    'preset.drone_sub.0': 'Altípus 0 (modellfüggő).',
    'preset.drone_sub.1': 'Altípus 1 (modellfüggő).',
    'preset.drone_sub.2': 'Altípus 2 (modellfüggő).',
    'preset.finish_action.go_home': 'Küldetés vége után hazatérés.',
    'preset.finish_action.no_action': 'Küldetés vége után nincs további művelet.',
    'preset.finish_action.auto_land': 'Küldetés vége után automatikus leszállás.',
    'preset.finish_action.goto_first_waypoint': 'Visszatérés az első waypoint-ra és lebegés.',
    'preset.fly_to_wayline_mode.safely': 'Biztonságos ráállás az útvonal kezdetére.',
    'preset.fly_to_wayline_mode.point_to_point': 'Közvetlen ráállás az útvonal kezdetére.',
    'preset.gimbal_pitch_mode.manual': 'A gimbal dőlése kézzel vezérelt.',
    'preset.gimbal_pitch_mode.use_point_setting': 'A gimbal dőlése pontszinten követi a waypoint beállítását.',
    'preset.waypoint_heading_mode.follow_wayline': 'A repülőgép orra az útvonal irányát követi.',
    'preset.waypoint_heading_mode.manually': 'A yaw kézzel vezérelt a szakasz során.',
    'preset.waypoint_heading_mode.fixed': 'A yaw rögzített irányon marad.',
    'preset.waypoint_heading_mode.smooth_transition': 'Sima yaw átmenet a waypoint-ok között.',
    'preset.waypoint_heading_path_mode.follow_bad_arc': 'A rövidebb yaw íven fordul.',
    'preset.waypoint_heading_path_mode.clockwise': 'Óramutató járásával megegyező yaw átmenet.',
    'preset.waypoint_heading_path_mode.counter_clockwise': 'Óramutató járásával ellentétes yaw átmenet.',
    'preset.waypoint_turn_mode.to_point_stop_discontinuity': 'Egyenes repülés, megállás a waypoint-nál (nem folytonos görbület).',
    'preset.waypoint_turn_mode.to_point_stop_continuity': 'Íves repülés, megállás a waypoint-nál (folytonos görbület).',
    'preset.waypoint_turn_mode.to_point_pass_continuity': 'Íves repülés, áthaladás megállás nélkül.',
    'preset.waypoint_turn_mode.coordinate_turn': 'Koordinált forduló, korábbi ívbelépéssel.',
    'preset.action_group_mode.sequence': 'Az akciók sorrendben futnak le.',
    'preset.action_trigger_type.reach_point': 'A trigger a waypoint elérésekor aktiválódik.',
    'preset.action_trigger_type.between_adjacent_points': 'A trigger két szomszédos waypoint között aktiválódik.',
    'preset.action_trigger_type.multiple_timing': 'A trigger időzítési/intervallum paraméter szerint aktiválódik.',
    'preset.execute_rc_lost_action.go_back': 'RC kapcsolatvesztés esetén visszatérési művelet.',
    'preset.exit_on_rc_lost.execute_lost_action': 'RC kapcsolatvesztéskor a beállított lost-action fut le.',
    'preset.altitude_mode.absolute': 'Abszolút magasság mód.',
    'preset.altitude_mode.relative_to_ground': 'A magasság a terephez viszonyított.',
    'preset.altitude_mode.clamp_to_ground': 'A pont terepre illesztése.',
    'preset.bool.off_false': 'Kikapcsolva / hamis',
    'preset.bool.on_true': 'Bekapcsolva / igaz',
    'preset.default_suffix': '(*alapértelmezés)',
    'value_help.height_mode.relative_to_start_point': 'A magasság a felszállási referenciaponthoz viszonyított.',
    'value_help.height_mode.egm96': 'A magasság geoid-referált ASL (EGM96) értelmezésű.',
    'value_help.height_mode.wgs84': 'A magasság WGS84 ellipszoid magasságként értelmezett.',
    'value_help.height_mode.real_time_follow_surface': 'A magasság valós időben követi a domborzatot (felszínhez viszonyított).',
    'value_help.altitude_mode.absolute': 'KML abszolút magasság mód.',
    'value_help.altitude_mode.relative_to_ground': 'A magasság a terephez viszonyított.',
    'value_help.altitude_mode.clamp_to_ground': 'A pont terepre van illesztve.',
    'value_help.drone_sub.0': 'Altípus 0 (modellfüggő).',
    'value_help.drone_sub.1': 'Altípus 1 (modellfüggő).',
    'value_help.drone_sub.2': 'Altípus 2 (modellfüggő).',
    'kmz_action.tooltip.gimbal_rotate': 'Gimbal forgatása konkrét szögekre.',
    'kmz_action.tooltip.gimbal_evenly_rotate': 'Egyenletes gimbal átforgatás.',
    'kmz_action.tooltip.focus': 'Fókusz művelet indítása.',
    'kmz_action.tooltip.take_photo': 'Fotó készítése.',
    'kmz_action.tooltip.oriented_shoot': 'Irányított felvétel akció teljes payload paraméterezéssel.',
    'kmz_action.tooltip.start_record': 'Rögzítés indítása.',
    'kmz_action.tooltip.stop_record': 'Rögzítés leállítása.',
    'kmz_action.tooltip.zoom': 'Gyújtótávolság/zoom beállítása.',
    'kmz_action.tooltip.custom_dir_name': 'Egyedi könyvtárnév kontextus beállítása.',
    'kmz_action.tooltip.hover': 'Egy helyben lebegés megadott ideig.',
    'kmz_action.tooltip.rotate_yaw': 'Légi jármű yaw forgatása.',
    'kmz_action.param.gimbalHeadingYawBase': 'Yaw referencia a gimbal forgatáshoz.',
    'kmz_action.param.gimbalRotateMode': 'Gimbal forgatási mód.',
    'kmz_action.param.gimbalPitchRotateEnable': 'Pitch forgatás engedélyezése.',
    'kmz_action.param.gimbalPitchRotateAngle': 'Cél pitch szög (fok).',
    'kmz_action.param.gimbalRollRotateEnable': 'Roll forgatás engedélyezése.',
    'kmz_action.param.gimbalRollRotateAngle': 'Cél roll szög (fok).',
    'kmz_action.param.gimbalYawRotateEnable': 'Yaw forgatás engedélyezése.',
    'kmz_action.param.gimbalYawRotateAngle': 'Cél yaw szög (fok).',
    'kmz_action.param.gimbalRotateTimeEnable': 'Forgatási idő vezérlés engedélyezése.',
    'kmz_action.param.gimbalRotateTime': 'Forgatás időtartama (s).',
    'kmz_action.param.payloadPositionIndex': 'Payload rögzítési index.',
    'kmz_action.param.focusX': 'Fókusz középpont X normalizált képi koordinátában.',
    'kmz_action.param.focusY': 'Fókusz középpont Y normalizált képi koordinátában.',
    'kmz_action.param.focusRegionWidth': 'Fókuszterület szélessége normalizált koordinátában.',
    'kmz_action.param.focusRegionHeight': 'Fókuszterület magassága normalizált koordinátában.',
    'kmz_action.param.isPointFocus': 'Pontfókusz jelző.',
    'kmz_action.param.isInfiniteFocus': 'Végtelen fókusz jelző.',
    'kmz_action.param.isCalibrationFocus': 'Kalibrációs fókusz jelző.',
    'kmz_action.param.fileSuffix': 'A kimeneti fájlnév utótagja.',
    'kmz_action.param.useGlobalPayloadLensIndex': 'Globális lencseindex használata (kapcsoló).',
    'kmz_action.param.focalLength': 'Objektív gyújtótávolság.',
    'kmz_action.param.aircraftHeading': 'Légi jármű heading (fok).',
    'kmz_action.param.accurateFrameValid': 'Pontos képkocka érvényességi jelző.',
    'kmz_action.param.targetAngle': 'Célszög paraméter.',
    'kmz_action.param.actionUUID': 'Akció egyedi azonosító (UUID).',
    'kmz_action.param.imageWidth': 'Képszélesség metaadat.',
    'kmz_action.param.imageHeight': 'Képmagasság metaadat.',
    'kmz_action.param.AFPos': 'Autofókusz pozíció metaadat.',
    'kmz_action.param.gimbalPort': 'Gimbal port index.',
    'kmz_action.param.orientedCameraType': 'Kamera típus azonosító.',
    'kmz_action.param.orientedFilePath': 'Irányított payload fájl útvonal/azonosító.',
    'kmz_action.param.orientedFileMD5': 'Irányított payload fájl MD5.',
    'kmz_action.param.orientedFileSize': 'Irányított payload fájl méret.',
    'kmz_action.param.orientedPhotoMode': 'Irányított fotó mód.',
    'kmz_action.param.isUseFocalFactor': 'Fókuszfaktor mód használata.',
    'kmz_action.param.hoverTime': 'Lebegési idő másodpercben.',
    'kmz_action.param.aircraftPathMode': 'Yaw pálya iránya.',
    'kmz_action.scope.legend.title': 'Paraméter scope jelmagyarázat',
    'kmz_action.scope.legend.col_template': 'Template',
    'kmz_action.scope.legend.col_waylines': 'Wayline',
    'kmz_action.scope.legend.col_color': 'Szín',
    'kmz_action.scope.legend.col_rule': 'Szabály',
    'kmz_action.scope.legend.template_only': 'T=1, W=0 - csak template.kml',
    'kmz_action.scope.legend.waylines_only': 'T=0, W=1 - csak waylines.wpml',
    'kmz_action.scope.legend.both': 'T=1, W=1 - mindkettő',
    'kmz_action.scope.legend.none': 'T=0, W=0 - nincs export',
    'kmz_action.scope.color.blue': 'Kék',
    'kmz_action.scope.color.red': 'Piros',
    'kmz_action.scope.color.purple': 'Lila',
    'kmz_action.scope.color.default_black': 'Alapértelmezett (fekete)',
    'tooltip.finishAction': 'Küldetés végi művelet.',
    'explain.finishAction': 'Meghatározza, mi történjen az utolsó waypoint után (pl. `goHome`, `noAction`, egyes modelleken `autoLand`). Példa: felmérés végén `goHome`, helyszíni ellenőrzésnél `noAction`.',
    'tooltip.createTime': 'Fájl létrehozási időbélyeg.',
    'explain.createTime': 'A tervfájl létrehozási ideje Unix időbélyegként (ms). Inkább metaadat, a repülési geometriát nem módosítja. Példa: `1710000000000`.',
    'tooltip.updateTime': 'Fájl utolsó módosítási időbélyeg.',
    'explain.updateTime': 'A tervfájl utolsó frissítési ideje Unix időbélyegként (ms). Nyomkövetéshez hasznos, repülési útvonalat nem változtat. Példa: export után új értéket kap.',
    'tooltip.globalUseStraightLine': 'Globális egyenes szakasz-közelítés.',
    'explain.globalUseStraightLine': 'A görbületes fordulási módoknál szabályozza, hogy a gép a szakaszt mennyire közelítse egyenes vonallal (`0`/`1`). Példa: `1` esetén feszesebb, egyenesebb átmenet két pont között.',
    'tooltip.waylineCoordinateSysParam': 'Koordináta-rendszer beállítási blokk.',
    'explain.waylineCoordinateSysParam': 'A waypoint koordináta- és magassági referencia fő blokkja (`coordinateMode`, `heightMode`, `positioningType`). Példa: `WGS84 + relativeToStartPoint + GPS`.',
    'tooltip.globalWaypointHeadingParam': 'Globális yaw beállítási blokk.',
    'explain.globalWaypointHeadingParam': 'A teljes útvonalra érvényes heading/yaw paramétereket tartalmazza. Ez akkor hat, ha a waypointnál `useGlobalHeadingParam=1`. Példa: minden pont `followWayline` módban.',
    'tooltip.globalWaypointTurnMode': 'Globális fordulási mód.',
    'explain.globalWaypointTurnMode': 'A waypointok közti alap fordulási geometriát adja meg (`coordinateTurn`, `toPointAndStopWithDiscontinuityCurvature`, `toPointAndStopWithContinuityCurvature`, `toPointAndPassWithContinuityCurvature`). Példa: folyamatos áthaladáshoz `toPointAndPassWithContinuityCurvature`.',
    'tooltip.heightMode': 'Template magassági referencia.',
    'explain.heightMode': 'A `template.kml` `height` mezőinek vonatkoztatási rendszere (`EGM96`, `relativeToStartPoint`, `realTimeFollowSurface`). Ez mondja meg, hogyan kell a `height` értéket értelmezni, és ebből hogyan kell az ugyanazon fizikai magasságot leíró `executeHeight` értéket előállítani, ha az `executeHeightMode` eltér. Azonos referencia esetén a két szám egyezhet, eltérő referencia esetén konverzió kell.',
    'tooltip.executeHeightMode': 'Végrehajtási magassági referencia.',
    'explain.executeHeightMode': 'A `waylines.wpml` `executeHeight` mezőinek referencia-rendszere (`WGS84`, `relativeToStartPoint`, `realTimeFollowSurface`). Ez határozza meg, milyen rendszerben kell a végrehajtási magasságot tárolni. Ha eltér a `heightMode`-tól, akkor a `height` és az `executeHeight` ugyanazt a fizikai magasságot csak eltérő referencia szerint írja le, ezért köztük átszámolás szükséges.',
    'tooltip.globalHeight': 'Globális waypoint magasság.',
    'explain.globalHeight': 'A teljes útvonal alapértelmezett magassága (a választott magassági mód szerint), ha a pontok globális magasságot használnak. Példa: minden pont 80 m, `useGlobalHeight=1`.',
    'tooltip.ellipsoidHeight': 'Ellipszoid magasság (WGS84).',
    'explain.ellipsoidHeight': 'A pont vagy útvonal magassága WGS84 ellipszoidhoz viszonyítva. A `height` mező párja, ugyanazon hely két eltérő referencia síkkal. Példa: import során együtt frissül a `height` értékkel.',
    'tooltip.height': 'Waypoint magasság (helyi érték).',
    'explain.height': 'A pont `template.kml`-beli magassága a `heightMode` szerint. Ugyanazt a fizikai magasságot írja le, mint a `waylines.wpml`-ben tárolt `executeHeight`, csak a template referencia-rendszerében. Ha a `heightMode` és az `executeHeightMode` azonos, a két érték megegyezhet; ha eltér, akkor a rendszer konvertál közöttük.',
    'tooltip.executeHeight': 'Végrehajtási magasság pontonként.',
    'explain.executeHeight': 'A pont tényleges végrehajtási magassága a `waylines.wpml` fájlban, az `executeHeightMode` szerint értelmezve. Ugyanannak a pontnak a `height` mezőjével együtt kell konzisztensnek lennie: azonos referencia esetén egyezhetnek, eltérő referencia esetén a két mező ugyanazt a fizikai magasságot eltérő rendszerben tárolja.',
    'tooltip.index': 'Waypoint sorszám.',
    'explain.index': 'Egyedi pontazonosító az útvonalon belül, folyamatosan növekvő sorrendben 0-tól. Példa: `0,1,2,3` kihagyás nélkül.',
    'tooltip.coordinates': 'Waypoint koordináta.',
    'explain.coordinates': 'KML koordináta mező (hosszúság,szélesség[,magasság]) a pont helyéhez. Példa: `17.779312,47.140928`.',
    'tooltip.waypointHeadingParam': 'Pontszintű heading blokk.',
    'explain.waypointHeadingParam': 'A waypoint yaw-orientációjának összetett beállításait tartalmazza (mód, szög, POI). Példa: `waypointHeadingMode=manually`, `waypointHeadingAngle=45`.',
    'tooltip.waypointTurnParam': 'Pontszintű fordulási blokk.',
    'explain.waypointTurnParam': 'A fordulás profilját és csillapítását szabályozza adott ponton. Példa: folyamatos ívhez `coordinateTurn` + `waypointTurnDampingDist`.',
    'tooltip.gimbalPitchAngle': 'Template pont gimbal pitch.',
    'explain.gimbalPitchAngle': 'A `template.kml` waypointnál tárolt gimbal dőlés-szög (előírt pontbeállítás). Nem azonos a végrehajtási `waypointGimbalPitchAngle` mezővel. Példa: `-45` lefelé döntés.',
    'tooltip.waypointGimbalHeadingParam': 'Végrehajtási gimbal heading blokk.',
    'explain.waypointGimbalHeadingParam': 'A `waylines.wpml` pontonkénti gimbal-orientációs csomópontja (pitch/yaw komponensekkel). Példa: végrehajtáskor külön yaw és pitch célérték.',
    'tooltip.waypointGimbalPitchAngle': 'Végrehajtási gimbal pitch.',
    'explain.waypointGimbalPitchAngle': 'A gimbal dőlésének célértéke a végrehajtási blokkon belül. Példa: inspeckciónál `-60` a tetőfelülethez.',
    'tooltip.waypointGimbalYawAngle': 'Végrehajtási gimbal yaw.',
    'explain.waypointGimbalYawAngle': 'A gimbal vízszintes elfordításának célértéke a végrehajtási blokkban. Példa: oldalirányú nézethez `90`.',
    'tooltip.gimbalPitchMode': 'Globális gimbal pitch mód.',
    'explain.gimbalPitchMode': 'Meghatározza, hogy a gimbal dőlése globális logikát vagy pontszintű értéket kövessen. Példa: `usePointSetting` esetén minden pont saját pitch-et kap.',
    'tooltip.waypointHeadingAngle': 'Yaw célszög ponton.',
    'explain.waypointHeadingAngle': 'A repülőgép cél heading szöge fokban az adott waypointnál (módtól függően). Példa: `90` = kelet felé nézés.',
    'tooltip.waypointHeadingAngleEnable': 'Yaw szög engedélyezése ponton.',
    'explain.waypointHeadingAngleEnable': 'Kapcsoló, hogy a pont explicit heading szöge érvényesüljön-e (`0`/`1`). Példa: `1` esetén a `waypointHeadingAngle` kötelezően hat.',
    'tooltip.waypointHeadingPoiIndex': 'POI index headinghez.',
    'explain.waypointHeadingPoiIndex': 'A heading-blokkban hivatkozott POI sorszáma, ha a nézési irány célponthoz kötött. Példa: több POI esetén `2` a harmadik célpontra mutat.',
    'tooltip.waypointPoiPoint': 'POI koordináta headinghez.',
    'explain.waypointPoiPoint': 'Célpont koordináta (lon,lat,alt), amely felé a heading irányulhat. Példa: toronyközép koordinátája POI-ként megadva.',
    'tooltip.waypointTurnDampingDist': 'Fordulási csillapítási távolság.',
    'explain.waypointTurnDampingDist': 'Megadja, milyen távolsággal a pont előtt kezdjen íves fordulót a gép. Példa: `8` m értékkel lágyabb átmenet nagyobb sebességnél.',
    'tooltip.waypointWorkType': 'Waypoint munka-típus jelző.',
    'explain.waypointWorkType': 'DJI belső célmező, amely speciális munkafolyamatoknál kap szerepet. Általános waypoint küldetésnél tipikusan alapértéken marad. Példa: importált RC-fájl értékének változatlan megtartása.',
    'tooltip.templateType': 'Útvonal-template típusa.',
    'explain.templateType': 'A sablon jellegét adja meg (`waypoint`, `mapping2d`, `mapping3d`, `mappingStrip`), ami meghatározza a kötelező mezőket. Példa: klasszikus pontrepüléshez `waypoint`.',
    'tooltip.coordinateMode': 'Koordináta-rendszer mód.',
    'explain.coordinateMode': 'A földrajzi koordináták rendszere, DJI WPML-ben jellemzően `WGS84`. Példa: külső GIS-ből importált pontok is WGS84-ben legyenek.',
    'tooltip.positioningType': 'Pozicionálási forrás típusa.',
    'explain.positioningType': 'A navigációs/pozicionálási jelleg megjelölése (pl. `GPS`). Ez a küldetés kompatibilitási metaadata is. Példa: szabványos GNSS útvonalnál `GPS`.',
    'tooltip.caliFlightEnable': 'Kalibrációs repülés kapcsoló.',
    'explain.caliFlightEnable': 'Bizonyos template folyamatoknál a kalibrációs jelleg engedélyezését jelzi (`0`/`1`). Általános waypoint küldetésnél általában kikapcsolt. Példa: normál küldetésnél `0`.',
    'tooltip.flyToWaylineMode': 'Első waypoint megközelítési mód.',
    'explain.flyToWaylineMode': 'Meghatározza, hogyan jusson a gép az első pontra (pl. `safely`, `pointToPoint`). Példa: akadályos környezetben `safely` javasolt.',
    'tooltip.exitOnRCLost': 'RC jelvesztés viselkedés.',
    'explain.exitOnRCLost': 'Beállítja, hogy jelvesztéskor folytassa-e az útvonalat (`goContinue`) vagy váltson vészműveletre (`executeLostAction`). Példa: BVLOS logikánál `goContinue`.',
    'tooltip.executeRCLostAction': 'Jelvesztési vészművelet.',
    'explain.executeRCLostAction': 'Ha `exitOnRCLost=executeLostAction`, ez adja meg a konkrét műveletet (`hover`, `landing`, `goBack`). Példa: városi környezetben gyakori a `hover`.',
    'tooltip.droneInfo': 'Dróntípus azonosítási blokk.',
    'explain.droneInfo': 'A küldetéshez tartozó légijármű-modell adatait tartalmazza (`droneEnumValue`, `droneSubEnumValue`). Példa: M3T esetén `77` és `1`.',
    'tooltip.payloadEnumValue': 'Payload típuskód.',
    'explain.payloadEnumValue': 'A használt kamera/szenzor fő modellazonosítója. Meghatározza az elérhető akcióparamétereket és kompatibilitást. Példa: Mavic 3 Enterprise kamera-kódja.',
    'tooltip.payloadSubEnumValue': 'Payload altípuskód.',
    'explain.payloadSubEnumValue': 'A payload pontos altípusát jelöli a fő típuson belül. Import/export kompatibilitásnál fontos. Példa: termál és normál variáns megkülönböztetése.',
    'tooltip.payloadInfo': 'Payload azonosítási blokk.',
    'explain.payloadInfo': 'A használt payload típusát és rögzítési pozícióját írja le (`payloadEnumValue`, `payloadSubEnumValue`, `payloadPositionIndex`). Példa: fő gimbal kamera `payloadPositionIndex=0`.',
    'tooltip.payloadParam': 'Payload-specifikus paraméterblokk.',
    'explain.payloadParam': 'A payload működési beállításait tartalmazza (pl. fénymérés, LiDAR visszatérési mód, mintavétel). Példa: LiDAR feladathoz `returnMode=dualReturn` és `samplingRate=240000`.',
    'tooltip.meteringMode': 'Payload fénymérési mód.',
    'explain.meteringMode': 'A kamera fénymérésének módja: `average` (globális átlag) vagy `spot` (pontszerű). Példa: kontrasztos jelenetnél `spot` segíthet a célterületre mérni.',
    'tooltip.dewarpingEnable': 'Torzításkorrekció kapcsoló.',
    'explain.dewarpingEnable': 'Objektív torzításkorrekció bekapcsolása (`0`/`1`). Példa: `1` esetén a rendszer dewarpinget alkalmaz a támogatott payloadon.',
    'tooltip.returnMode': 'LiDAR visszaverődés mód.',
    'explain.returnMode': 'LiDAR visszatérési mód: `singleReturnStrongest`, `dualReturn`, `tripleReturn`. Példa: növényzetnél `dualReturn` több réteginformációt adhat.',
    'tooltip.samplingRate': 'LiDAR mintavételi frekvencia.',
    'explain.samplingRate': 'A LiDAR mintavételi frekvenciája Hz-ben. Tipikus értékek: `60000`, `80000`, `120000`, `160000`, `180000`, `240000`. Példa: részletesebb felhőhöz nagyobb érték.',
    'tooltip.scanningMode': 'LiDAR szkennelési mód.',
    'explain.scanningMode': 'A szkennelés karaktere: `repetitive` vagy `nonRepetitive`. Példa: a feladat geometriájához igazítva válaszd a kívánt mintázatot.',
    'tooltip.modelColoringEnable': 'Valódi színű modellezés kapcsoló.',
    'explain.modelColoringEnable': 'A színezett modellgenerálás engedélyezése (`0`: nincs színezés, `1`: true color). Példa: vizuális prezentációhoz `1`, nyers geometriához `0`.',
    'tooltip.waylineAvoidLimitAreaMode': 'Korlátozott tér elkerülési mód.',
    'explain.waylineAvoidLimitAreaMode': 'A végrehajtásnál a limitált területek kezelésének módját jelzi (ha az adott platform támogatja). Példa: kerülő viselkedés bekapcsolása geofence-közelben.',
    'tooltip.useGlobalHeight': 'Globális magasság használata.',
    'explain.useGlobalHeight': 'Pontszinten kapcsolja, hogy a `globalHeight` érték öröklődjön (`1`) vagy helyi `height/ellipsoidHeight` legyen használva (`0`). Példa: egyetlen pontot eltérő magasságra teszel `0`-val.',
    'tooltip.useGlobalSpeed': 'Globális sebesség használata.',
    'explain.useGlobalSpeed': 'Pontszintű kapcsoló az `autoFlightSpeed` és a helyi `waypointSpeed` között (`1`/`0`). Példa: fotópontnál lassítás miatt `0` + `waypointSpeed=3`.',
    'tooltip.useGlobalHeadingParam': 'Globális heading használata.',
    'explain.useGlobalHeadingParam': 'Pontszinten dönti el, hogy a globális heading blokk vagy a helyi `waypointHeadingParam` legyen érvényes. Példa: egy POI-követő pontnál `0`.',
    'tooltip.useGlobalTurnParam': 'Globális fordulás használata.',
    'explain.useGlobalTurnParam': 'Pontszintű kapcsoló a globális fordulási mód és a helyi `waypointTurnParam` között. Példa: egy szűk sarokpontnál helyi fordulási profilhoz `0`.',
    'tooltip.useStraightLine': 'Helyi egyenes szakasz-közelítés.',
    'explain.useStraightLine': 'Pontszintű felülírás a szakasz geometriájára görbületes módokban. Példa: kritikus szakaszon `1`, miközben globálisan `0`.',
    'tooltip.isRisky': 'DJI kockázati jelző.',
    'explain.isRisky': 'A DJI rendszer által használt pontszintű rizikóflag (`0`/`1`), főként kompatibilitási/meta célra. Példa: RC exportból jött érték változatlanul mentve.',
    'tooltip.autoFlightSpeed': 'Globális repülési sebesség.',
    'explain.autoFlightSpeed': 'A template-ből generált útvonal alap sebessége m/s-ban, ha nincs pontszintű felülírás. Példa: felmérésnél `7`, részletfotózásnál alacsonyabb.',
    'tooltip.waypointSpeed': 'Pontszintű repülési sebesség.',
    'explain.waypointSpeed': 'Az adott waypointhoz tartozó helyi sebesség m/s-ban, ha `useGlobalSpeed=0`. Példa: akciópont előtt `2.5` m/s.',
    'tooltip.waypointHeadingMode': 'Yaw vezérlési mód.',
    'explain.waypointHeadingMode': 'A heading viselkedés típusa (pl. `followWayline`, `manually`, `smoothTransition`, `fixed`). Példa: filmszerű átmenethez `smoothTransition`.',
    'tooltip.waypointTurnMode': 'Fordulási profil mód.',
    'explain.waypointTurnMode': 'A pont elhagyásának geometriája (megálló vagy áthaladó, folytonos vagy töréspontos). Példa: folyamatos pályához `toPointAndPassWithContinuityCurvature`.',
    'tooltip.takeOffSecurityHeight': 'Biztonságos felszállási magasság.',
    'explain.takeOffSecurityHeight': 'A felszállás után elért biztonsági magasság, mielőtt a gép az első waypoint felé indul. Példa: akadályos környezetben nagyobb érték (pl. `40` m).',
    'tooltip.globalTransitionalSpeed': 'Átmeneti (belépési/visszaállási) sebesség.',
    'explain.globalTransitionalSpeed': 'A sebesség, amellyel a gép az útvonal első pontjára, illetve megszakítás utáni visszaálláskor repül. Példa: stabil átmenethez `8` m/s.',
    'tooltip.payloadPositionIndex': 'Payload rögzítési pozíció.',
    'explain.payloadPositionIndex': 'A felszerelési hely indexe (`0/1/2`), modellenként eltérő fizikai pozícióval. Példa: Mavic 3 Enterprise fő gimbalhoz jellemzően `0`.',
    'tooltip.droneEnumValue': 'Drón fő típuskód.',
    'explain.droneEnumValue': 'A légijármű modellcsalád azonosítója (pl. `77` = M3E/M3T/M3M). Ez határozza meg a támogatott mezőket és tartományokat. Példa: M3E projektnél `77`.',
    'tooltip.droneSubEnumValue': 'Drón altípuskód.',
    'explain.droneSubEnumValue': 'A kiválasztott dróncsaládon belüli konkrét modell azonosítója. Példa: M3T esetén a `77` főtípushoz tipikusan `1`.',
    'tooltip.missionConfig': 'Küldetés globális konfiguráció blokk.',
    'explain.missionConfig': 'A route teljes végrehajtási alapbeállításait tartalmazza (RTH/jelvesztés/felszállás/drón/payload stb.). Példa: `finishAction`, `takeOffSecurityHeight` és `droneInfo` együtt itt él.',
    'tooltip.templateId': 'Template azonosító.',
    'explain.templateId': 'A sablon egyedi ID-ja a KMZ-n belül, amely összekapcsolja a `template.kml` és `waylines.wpml` részeket. Példa: első sablonnál `0`.',
    'tooltip.waylineId': 'Wayline azonosító.',
    'explain.waylineId': 'A végrehajtható útvonal (wayline) egyedi ID-ja a KMZ-n belül. Több útvonal esetén monoton növekvő. Példa: `0`, `1`, `2`.',
    'tooltip.distance': 'Szakasz/útvonal távolság érték.',
    'explain.distance': 'Távolság alapú numerikus mező, amelyet egyes WPML elemek (pl. trigger vagy statisztika) használnak méterben. Példa: egyenlő távú fotózásnál trigger távolság `distance=15`.',
    'tooltip.duration': 'Időtartam érték.',
    'explain.duration': 'Időalapú numerikus mező, tipikusan másodpercben vagy becsült küldetésidőként. Példa: időalapú triggernél `duration=2` két másodperces intervallumot jelent.',
}

const PORTAL_I18N_BY_LOCALE = {
  hu: I18N_HU
}

if (typeof window !== 'undefined') {
  window.PORTAL_I18N_HU = I18N_HU
  window.PORTAL_I18N = Object.assign({}, window.PORTAL_I18N || {}, PORTAL_I18N_BY_LOCALE)
}

export {
  I18N_HU,
  PORTAL_I18N_BY_LOCALE
}
